import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { createRequestActions } from './../../../store/external/request-reducer/create-request.reducer';
import { fileAttachmentActions } from './../../../store/external/common-reducer/file-attachment.reducer';
import Translation from '../../common/translation/translation.component';
import Icons from "../../icon";
import "./file-attachment.component.css";
import 'react-toastify/dist/ReactToastify.css';
import ButtonIcon from '../../button';
import { NotificationModal } from '../modal/notification-modal.component';
import moment from 'moment';
class FileAttachment extends Component {
    constructor(props) {
        super(props);
        this.fileRef = React.createRef();
        this.state = {
            selectedFile: null,
            files: [],
            attaching: false,
            showModal: false,
            modalMessage: ''
        };
    }

    handleConfirmationModal = () => {
        this.setState(prevState => ({ showModal: !prevState.showModal}));
    }
   

    onclickAttacheFile = () => {
        var inputFile = document.getElementById("request-attach-file");

        this.setState({ attaching: true })
        inputFile.click();

        document.body.onfocus = this.fileFocus;
    };

    resetFileInput = () => {
        this.fileRef.current.value = null;
    }

    onFileChange = (e) => {
        var files = e.target.files;
        var acceptedFiles = ['.csv', '.xls', '.xlsx', '.docx', '.txt', '.zip', '.msg', '.pdf', '.msg', '.png', '.jpg', '.jpeg', '.bmp'];
        const filename = files[0]?.name ?? '';
        const extIndex = filename?.lastIndexOf('.') ?? '';
        const extension = filename?.substring(extIndex + 1) ?? '';
        this.setState({ attaching: false });

        let attachFiles = this.props.fileAttachment.files;
        var fileCount = (files.length + attachFiles.length);
        const totalSize = Array.from(attachFiles).reduce((sum, file) => sum + file.size, 0);

        if (fileCount > 3) {          
            this.setState({
                modalMessage: 'Number of files exceeds the allowable limit of 3',
                showModal: true
            })
        } else {
            for (var i = 0; i < files.length; i++) {
                var fileType = `.${extension}`;
                if (!acceptedFiles.includes(fileType.toLowerCase())) {
                    this.setState({
                        modalMessage: `Only files with the following format are allowed: CSV, XLS, XSLX, DOCX, PDF, TXT, ZIP, MSG (email), PNG, JPG, JPEG, BMP`,                       
                        showModal: true
                    })
                }
                else if (files[i].size >= 10 * 1024 * 1024 || ((files[i].size + totalSize) >= 10 * 1024 * 1024)) {
                    this.setState({
                        modalMessage: 'Total file size exceeds the allowable limit of 10 MB',
                        showModal: true
                    })
                } else {
                    attachFiles.push(files[i]);
                }
            }

            this.props.updateAttachFile(attachFiles);
        }
        this.resetFileInput();
    };

    getToastSettings = () => {
        return {
            position: "top-center",
            theme: "colored",
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        };
    }

    removeFileByName = (name) => {
        //const { updateOrderAmmendFileNames, orderFile, orderAmmendFileNames, addOrderFile, isDisabled } = this.props;

        //if (uploadingAPFile || isDisabled)
        //return;

        const { files } = this.props.fileAttachment;

        var newAttachFile = files.filter(function (obj) {
            return obj.name !== name;
        });
        //if (orderAmmendFileNames != undefined) {
        //    var oldFileNames = orderAmmendFileNames.filter(function (n) {
        //        return n !== name;
        //    });
        //    updateOrderAmmendFileNames(oldFileNames);
        //}
        var inputFile = document.getElementById("request-attach-file");
        inputFile.value = "";

        this.props.updateAttachFile(newAttachFile);
    }

    truncateFileName = (name) => {
        const maxLength = 15;
        const truncatedLength = 7;
        const dateUploaded = moment(new Date()).format("MM-DD-YY");
        const extIndex = name.lastIndexOf('.');
        const baseName = name.substring(0, extIndex);
        const extension = name.substring(extIndex);
    
        if (baseName.length > maxLength) {
            const truncatedBaseName = baseName.substring(0, truncatedLength) + '...';
            return `${truncatedBaseName}${dateUploaded}${extension}`;
        } else {
            return `${baseName}${dateUploaded}${extension}`;
        }
    }

    toolTipName =(name) => {
        const dateUploaded = moment(new Date()).format("MM-DD-YY");
        const extIndex = name.lastIndexOf('.');
        const baseName = name.substring(0, extIndex);
        const extension = name.substring(extIndex);
        return `${baseName}${dateUploaded}${extension}`;
    }

    updateToolTipName = (name) => {
        const parts = name.split('-');
        const datePart = parts.slice(-3).join('-');
        let newFile =  parts.slice(0, -3).join('-');
        let modifiedFilename = `${newFile}${datePart}`
        return modifiedFilename;
    }

    displayAttachment = (files) => {
        //const { orderAmmendFileNames } = this.props;
        const { isUpdate, requestFileName } = this.props;
        if(!isUpdate){
            if (files && files.length > 0) {
                return files.map((x, i) => {
                    return (
                        <Row key={i}>
                            <div>
                                <div className="file-display">
                                    <Icons
                                        customClassName="icon-file-clip"
                                        name="paper-clip-solid"
                                        size="15px"
                                        containerClass="icon-paper-clip-file-container"
    
                                    />
                                    <div className="btn-tooltiptext">
                                        <span data-dz-name className='file-name'>{this.truncateFileName(x.name)}</span>   
                                        <span className="tooltip-text">{this.toolTipName(x.name)}</span>
                                    </div> 
                                   
                                    <Icons
                                        name="x-solid"
                                        size="9px"
                                        customClassName="icon-right"
                                        onClick={(e) => this.removeFileByName(x.name)}
                                    />
                                </div>
                            </div>
                        </Row>
                    )
                })
            }
        }
        else{
            if (requestFileName && requestFileName.length > 0) {
                return requestFileName.map((x, i) => {
                    return (
                        <Row key={i}>
                            <div>
                                <div className="file-display">
                                    <Icons
                                        customClassName="icon-file-clip"
                                        name="paper-clip-solid"
                                        size="15px"
                                        containerClass="icon-paper-clip-file-container"
    
                                    />
                                    <div className="btn-tooltiptext">
                                        <span data-dz-name className='file-name'>{this.truncateFileName(x)}</span>
                                        <span className="tooltip-text">{this.updateToolTipName(x)}</span>
                                    </div>                                  
                                </div>
                            </div>
                        </Row>
                    )
                })
            }
        }
        //if (orderAmmendFileNames && orderAmmendFileNames.length > 0) {
        //    return orderAmmendFileNames.map((x, i) => {
        //        return (
        //            <Row key={i}>
        //                <div>
        //                    <div>
        //                        <span onClick={(e) => this.removeFileByName(x)} data-dz-remove></span>
        //                    </div>
        //                    <div><span data-dz-name>{x}</span></div>
        //                </div>
        //            </Row>
        //        )
        //    })
        //}
    };

    render() {
        const { files, disableAttchBtn } = this.props.fileAttachment;
        const { isUnmounted, isUpdate } = this.props;
        return (
            <div>
                {isUnmounted ? this.onRemoveData() : null}
                <Row>
                    <Col>
                        <div className="save-btn-container file-attach-tooltip">
                            <div className="tooltip-container">
                                <div className="btn-tooltiptext">
                                    <ButtonIcon onClick={(e) => this.onclickAttacheFile()} iconLeft="paper-clip-light" iconSize="17px" isDisable={isUpdate ? true : disableAttchBtn} customClassName="header-option-list header-filter-button" labelName="Attach File">
                                        <input hidden={true} id="request-attach-file" multiple type="file" className="a-f-hide upload-file-btn" ref={this.fileRef} onChange={(e) => this.onFileChange(e)} accept=".pdf,.msg,.docx,.xls,.xlsx,.txt" />
                                    </ButtonIcon>

                                    <div className="save-tooltip-text-container">
                                        <span className="tooltip-text-save">Attach and Save File</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row className='mt-2'>
                    <Col xs={12} md={12}>
                        {this.displayAttachment(files)}
                    </Col>
                </Row>
                <NotificationModal 
                    show={this.state.showModal}
                    title={'Confirmation'} 
                    customClass={'comment-notification-modal notification-footer'}
                    handleModal={this.handleConfirmationModal}
                    message={this.state.modalMessage} />
            </div>
        );
    }
}

export default connect(
    state => {
        const { createRequest, fileAttachment } = state;
        return {
            fileAttachment
            , createRequest
        };
    }
    , dispatch =>
        bindActionCreators(
            Object.assign({}, createRequestActions
                , fileAttachmentActions),
            dispatch
        )
)(FileAttachment);